enum HANDLING_MODES {
  DEPOSIT = 'Deposit',
  DELIVERY = 'Delivery',
  HOME = 'Home',
}

export default HANDLING_MODES;
